export default () => ({
  init() {
    this.$root.querySelectorAll('input, select, textarea').forEach((input) => {
      input.dataset.erroneousValue = state(input)

      const toggle = () => this.toggle(input)
      const targets = input.type === 'radio' ? group(input) : [input]
      targets.forEach((target) => {
        target.addEventListener('input', toggle)
        target.addEventListener('change', toggle)
      })
    })
  },

  toggle(input) {
    this.$root.classList.toggle(
      'field-with-errors',
      state(input) == input.dataset.erroneousValue,
    )
  },
})

const group = (input) =>
  Array.from(
    (input.form ?? document).querySelectorAll("input[type='radio']"),
  ).filter((radio) => radio.name === input.name)

const state = (input) => {
  if (input.type === 'radio') {
    const checked = group(input).find((radio) => radio.checked)
    return checked ? checked.value : ''
  }
  if (input.type === 'checkbox') return input.checked ? input.value : ''
  return input.value
}
